'use strict';

var humanizeDuration = require('humanize-duration');
var $ = require('jquery');
var _ = require('underscore');
var Radio = require('backbone.radio');
var moment = require('moment-timezone');
var maps = require('../../utilities/maps').default;
var CancelToast = require('../cancel-toast').default;
var Marionette = require('backbone.marionette');
var SocialMediaView = require('./social-media').default;
var AddToCalendarView = require('./add-to-calendar').default;
var Tracker = require('../../../analytics/events').default;
var polyglot = require('../../utilities/polyglot').default;
var LanguageCollection = require('../../collections/languages').default;
var AppointmentCollection = require('../../collections/appointments').default;
var Appointment = require('../../models/appointment').default;

export default Marionette.View.extend({

  className: 'appointment-details',
  childView: require('../cancel-toast'),
  childViewEventPrefix: false,
  template: require('./templates/details.hbs'),
  defaults: {
    showStaff: window.SETTINGS.show_staff_picker || window.SETTINGS.show_staff_assigned,
  },
  regions: {
    social: '.social-media',
    addToCalendar: '#add-to-calendar',
  },
  ui: {
    details: '.appointment-confirm-details',
    rightColumn: '.appointment-details-right-column',
    map: '.appointment-details-map',
    cancelButton: '.appointment-cancel-button',
    rescheduleButton: '.appointment-reschedule-button',
    cancelComplete: '.cancel-complete',
    cancelCompleteSuccess: '.cancel-complete .alert-success',
    cancelCompleteError: '.cancel-complete .alert-error',
  },
  events: {
    'click @ui.cancelButton': 'onClickCancelButton',
    'click @ui.rescheduleButton': 'onClickRescheduleButton',
  },
  childViewEvents: {
    'click:cancel': 'onChildClickCancel',
  },

  initialize: function (options) {
    this.initializeData();
    this.options = _.extend({}, this.defaults, this.options);
    this.languages = new LanguageCollection(window.LANGUAGES);
    this.showMessage = options.showMessage;
    this.socialMediaView = new SocialMediaView();
    this.addToCalendarView = new AddToCalendarView({
      model: this.model,
    });
    this.cancelToast = new CancelToast();
    this.listenTo(Radio.channel('complete-cancel'), 'complete:cancel', this.onCancelComplete);
    this.listenTo(Radio.channel('reschedule-error'), 'reschedule:error', this.onRescheduleError);
  },

  initializeData: function() {
    this.collection = new AppointmentCollection(window.APPOINTMENTS);
    this.model = this.collection.first();
    this.model.set('client_end', this.options.clientEnd);
    this.model.setTimezone(this.getTimezone(), this.getTimezoneAbbr());
    this.services = this.collection.length ? [] : this.model.services;
    this.setServices();
    this.time = this.getTime();
    this.timezoneAbbr = this.getTimezoneAbbr();
  },

  onRender: function () {
    if (this.isSharingSocialMedia()) {
      this.getRegion('social').show(this.socialMediaView);
    }

    if (window.SETTINGS.includes_ics && !window.SETTINGS.enable_meeting_links) {
      this.getRegion('addToCalendar').show(this.addToCalendarView);
    }

    this.ui.cancelComplete.hide();
  },

  serializeData: function () {
    var json = this.model.toJSON();
    json.canCancel = this.model.canCancel();
    json.canReschedule = this.model.canReschedule();
    json.canCancelOrReschedule = json.canCancel || json.canReschedule;
    json.rrule = this.model.get('rrule_summary');
    json.bookLink = this.getBookingLink(json);
    json.isHere = this.model.isHere();
    json.hasAddress = !this.model.isVirtual();
    json.showMessage = this.showMessage;
    json.isSharingSocialMedia = this.isSharingSocialMedia();
    json.start = this.time;
    json.timezoneAbbr = this.timezoneAbbr;
    json.cannotManageMessage = this.getCannotManageMessage();
    json.usesMeetingLinks = window.SETTINGS.enable_meeting_links;
    json.includesIcsFiles = window.SETTINGS.includes_ics;

    var location = this.model.getLocation();
    if (location) {
      json.location = location.toJSON();
    }
    json.services = _.map(this.model.getServices(), function(service) {
      return service.toJSON();
    });


    var staff = this.model.getStaff();
    if (this.options.showStaff && staff) {
      json.staff = staff.toJSON();
    } else {
      delete json.staff;
    }

    json.atLocation = this.getAtLocation(json.location.name);

    return json;
  },

  getCannotManageMessage: function() {
    if (this.model.get('rrule_summary')) {
      return polyglot.t('cancel.cannot_manage_recurrent');
    }

    var cannotManage = polyglot.t('cancel.cannot_manage');
    var noticeRequired = polyglot.t('cancel.notice_required', {
      days: humanizeDuration(moment.duration(window.SETTINGS.cancellation_allowance, 'minutes'), { language: $('html').attr('lang') }),
    });
    var appointmentInPast = polyglot.t('cancel.appointment_in_past');
    var contactVendor = '';
    var phone = this.model.get('location').phone;
    var cannotManageMessage = '';

    if (phone) {
      contactVendor = polyglot.t('cancel.contact_vendor', {
        vendor: window.SETTINGS.vendor_name,
        phone: phone,
      });
    } else {
      contactVendor = polyglot.t('cancel.contact_vendor_no_phone', {
        vendor: window.SETTINGS.vendor_name,
      });
    }

    const { start, timezone, location } = this.model.toJSON();

    if (moment().tz(timezone).diff(moment.tz(start, location.timezone).tz(timezone)) > 0) {
      cannotManageMessage = appointmentInPast;
    } else if (this.model.cancelEnabled()) {
      cannotManageMessage = `${cannotManage} ${noticeRequired} ${contactVendor}`;
    } else {
      cannotManageMessage = `${cannotManage} ${contactVendor}`;
    }

    return cannotManageMessage;
  },

  onDomRefresh: function () {
    if (this.model.isHere() && !this.model.isVirtual()) {
      this.renderMap();
    }
  },

  isSharingSocialMedia: function () {
    return window.SETTINGS.enable_social_media_sharing;
  },

  /**
   * Set page focus.
   */
  focus: function () {
    this.$el.find('.appointment-confirm-details .alert-info i').focus();
  },

  /**
   * Renders our interactable map.
   */
  renderMap: function () {
    var location = this.model.location;
    var latitude = parseFloat(location.get('latitude'));
    var longitude = parseFloat(location.get('longitude'));

    var map = new maps.Map(this.ui.map[0], {
      center: { lat: latitude, lng: longitude },
      zoom: 18,
      streetViewControl: false,
      mapTypeControl: false,
    });

    new maps.Marker({
      position: {
        lat: latitude,
        lng: longitude,
      },
      map: map,
      title: location.get('name'),
    });
  },

  /**
   * Link back to the start of the client view.
   *
   * @returns {string}
   */
  getBookingLink: function (json) {
    let link =  window.location.pathname + '?lang=' + this.languages.getCurrent();
    link += (json.appointmentclient[0].booking_shortcut
            && window.SETTINGS.use_booking_context)
            ? '&' + json.appointmentclient[0].booking_shortcut
            : '' ;

    return link;
  },

  /**
   * Formats the location's name.
   * @param name
   * @returns {string}
   */
  getAtLocation: function (name) {
    return '<strong>' + name + '</strong>';
  },

  getServiceNames: function () {
    var names = [];
    _.each(window.APPOINTMENTS, function (appointment) {
      names.push(appointment.service);
    });

    return names;
  },

  /**
   * Triggers the cancel toast to appear.
   *
   * @param evt
   */
  onClickCancelButton: function (evt) {
    evt.preventDefault();
    Tracker.trackView('cancel-toast');
    Radio.channel('cancel-toast').trigger('show', {
      parent: this,
      model: this.model,
      time: this.time,
      zone: this.timezoneAbbr,
      showNotes: this.model.showNotes(),
      isNotesRequired: this.model.isNotesRequired(),
    });
  },

  /**
   * Navigates to the reschedule page.
   *
   * @param evt
   */
  onClickRescheduleButton: function (evt) {
    var self = this;
    evt.preventDefault();

    this.model.isValidAppointment().done(function (data) {
      if (data.data.appointment[0].appointmentclient[0].cancelled) {
        Radio.channel('reschedule-error').trigger('reschedule:error');
        return;
      }
      window.APPOINTMENTS = _.map(data.data.appointment, function(appointment) {
        return new Appointment(appointment);
      });
      self.initializeData();
      Radio.channel('reschedule').trigger('set:appointment', self.model);
      Backbone.history.navigate(polyglot.t('pages.reschedule.slug'), { trigger: true });
    }).fail(function() {
      Radio.channel('reschedule-error').trigger('reschedule:error');
    });
  },

  onRescheduleError: function () {
    this.ui.details.hide();
    this.ui.rightColumn.hide();
    this.ui.cancelComplete.show();
    this.ui.cancelCompleteSuccess.hide();
  },

  /**
   * Removes appointment from the collection, removes visual elements re: the
   * appointment + cancel toast, and displays the cancel complete UI.
   */
  onCancelComplete: function () {
    this.ui.details.hide();
    this.ui.cancelComplete.show();
    this.ui.cancelCompleteError.hide();
    Radio.channel('cancel-toast').trigger('hide');
  },

  /**
   * Get the time to be passed to the cancel toast.
   *
   * @returns {*}
   */
  getTime: function () {
    var model = this.model.toJSON();
    var clientTimezone = model.clients[0].timezone;
    var locationTimezone = model.location['timezone'];
    var format = 'YYYY-MM-DD HH:mm:ss';
    var timezone = '';
    var stored = window.localStorage.getItem('timezone');
    if (clientTimezone !== null) {
      timezone = clientTimezone === locationTimezone ? locationTimezone
        : clientTimezone;
    } else {
      if (stored !== ('null' && null)) {
        timezone = stored;
      } else {
        timezone = locationTimezone;
      }
    }

    var start = moment.tz(model.start, locationTimezone).tz(timezone);

    return start.format(format);
  },

  getTimezoneAbbr: function () {
    const model = this.model.toJSON();
    const timezone = this.getTimezone();
    const start = moment.tz(model.start, timezone).tz(timezone);

    return start.zoneAbbr();
  },

  getTimezone: function () {
    const model = this.model.toJSON();
    const clientTimezone = model.clients[0]['timezone'];
    const locationTimezone = model.location['timezone'];
    const stored = window.localStorage.getItem('timezone');
    let timezone;
    if (stored !== ('null' && null)) {
      timezone = stored;
    } else if (clientTimezone) {
      timezone = clientTimezone;
      window.localStorage.setItem('timezone', clientTimezone);
    } else {
      timezone = locationTimezone;
    }

    return timezone;
  },

  /**
   * Get services from all appointments booked by the attendee and assign them
   * to the appointment displayed
   */
  setServices: function() {
    var self = this;
    var serviceId = [];

    if (self.collection.length) {
      self.collection.each(function(appointment) {
        serviceId.push(appointment.get('service_id'));
        self.services.push(appointment.services[0]);
      });
    } else {
      _.each(self.services, function(service) {
        serviceId.push(service.id);
      });
    }

    self.model.set('service_id', _.uniq(serviceId));
    self.model.services = _.uniq(self.services, 'id');
  },
});
